var thisWindowWidth;

$(document).ready(function () {
  thisWindowWidth = $(window).width();
  reSizeHomepageHeader();
});

$(window).on("resize", function () {
  // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
  if ($(window).width() != thisWindowWidth) {
    // Take note of updated window width in case of another resize
    thisWindowWidth = $(window).width();

    reSizeHomepageHeader();
  }
});

function reSizeHomepageHeader() {
  if ($(".single-page-banner h1").length > 0) {
    $(".single-page-banner h1").fitText(1.8, { maxFontSize: "83px" });
  }
}
